// Event detail Google Chart
import { ensureGoogleCharts } from './google_loader.js';

declare let google: any;

export function initEventChart(pts: Array<{ dt: string; val: number }>, dataname: string): void {
    ensureGoogleCharts().then(() => drawChart(pts, dataname));
}

function drawChart(pts: Array<{ dt: string; val: number }>, dataname: string): void {
    const data = new google.visualization.DataTable();
    data.addColumn('date', 'Date');
    data.addColumn('number', dataname);

    const rows = pts.map(p => [new Date(p.dt), p.val]);
    data.addRows(rows);

    const main = document.getElementById('main');
    const width = main ? main.offsetWidth : 800;
    const options = { width: width, height: width * 0.5 };

    const chart = new google.visualization.LineChart(document.getElementById('chart_div'));
    google.visualization.events.addListener(chart, 'select', () => {
        const selected = chart.getSelection()[0];
        if (selected) {
            data.getValue(selected.row, 0);
        }
    });
    chart.draw(data, options);
}
